import {
  ADD_ROLE,
  ADD_ROLE_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE,
  EDIT_ROLE,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  RESET_ROLE_STATE,
  SEARCH_ROLES,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  FETCH_ROLE_DETAILS_REQUEST,
  FETCH_ROLE_DETAILS_SUCCESS,
  FETCH_ROLE_DETAILS_FAILURE,
} from "../RoleTypes/RoleTypes";

export const addRoleRequest = (roleData) => ({
  type: ADD_ROLE_REQUEST,
  payload: roleData,
});

export const addRoleSuccess = (message) => ({
  type: ADD_ROLE_SUCCESS,
  payload: message,
});

export const addRoleFailure = (error) => ({
  type: ADD_ROLE_FAILURE,
  payload: error,
});

export const resetRoleState = () => ({
  type: RESET_ROLE_STATE,
});

export const fetchRolesRequest = () => ({
  type: FETCH_ROLES_REQUEST,
});

export const fetchRolesSuccess = (roles) => ({
  type: FETCH_ROLES_SUCCESS,
  payload: roles,
});

export const fetchRolesFailure = (error) => ({
  type: FETCH_ROLES_FAILURE,
  payload: error,
});

export const addRole = (role) => ({
  type: ADD_ROLE,
  payload: role,
});

export const editRole = (updatedRole) => ({
  type: EDIT_ROLE,
  payload: updatedRole,
});

export const deleteRole = (roleName) => ({
  type: DELETE_ROLE,
  payload: roleName,
});

export const searchRoles = (query) => ({
  type: SEARCH_ROLES,
  payload: query,
});

export const updateRoleRequest = (roleData, id) => ({
  type: UPDATE_ROLE_REQUEST,
  payload: { ...roleData, id },
});

export const updateRoleSuccess = (updatedRole) => ({
  type: UPDATE_ROLE_SUCCESS,
  payload: updatedRole,
});

export const updateRoleFailure = (error) => ({
  type: UPDATE_ROLE_FAILURE,
  payload: error,
});

export const deleteRoleRequest = (roleId) => ({
  type: DELETE_ROLE_REQUEST,
  payload: roleId,
});

export const deleteRoleSuccess = (roleId) => ({
  type: DELETE_ROLE_SUCCESS,
  payload: roleId,
});

export const deleteRoleFailure = (error) => ({
  type: DELETE_ROLE_FAILURE,
  payload: error,
});

export const fetchRoleDetailsRequest = (roleId) => ({
  type: FETCH_ROLE_DETAILS_REQUEST,
  payload: roleId,
});

export const fetchRoleDetailsSuccess = (roleData) => ({
  type: FETCH_ROLE_DETAILS_SUCCESS,
  payload: roleData,
});

export const fetchRoleDetailsFailure = (error) => ({
  type: FETCH_ROLE_DETAILS_FAILURE,
  payload: error,
});
